import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

import LogoBlack from '@/assets/logos/inavo.svg'

import './leftMenuLogo.scss'

const LeftMenuLogo = () => {
  return (
    <div className='left-menu-logo'>
      <Link to='/'>
        <motion.img
          className='left-menu-logo__img'
          src={LogoBlack}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 0.15,
            ease: 'easeOut',
          }}
        />
      </Link>
    </div>
  )
}

export default LeftMenuLogo
